module.exports = __webpack_public_path__ + "static/media/homebanner.80ed604c.jpg";